import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SuiContainer, SuiLabel } from '@splashthat/sui';
import FontPickerEditor from 'common/components/FontPicker';
import ColorPickerEditor from 'common/components/ColorPicker';

import { getColors } from 'common/entities/color/selectors';
import { getFonts } from 'common/entities/font/selectors';
import { getFormErrorStyles } from 'common/entities/form/styleConfiguration/selectors';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import {
    setFormErrorsColor,
    setFormErrorsFont,
    setFormErrorsFontsize,
} from 'common/entities/form/styleConfiguration/actions';
import {
    DEFAULT_FONT,
    DEFAULT_FONT_SIZE,
    DEFAULT_ERRORS_COLOR,
} from 'common/entities/form/styleConfiguration/defaultValues';
import { getFormId } from '../../../selectors';

import { ERRORS_FONT_LABEL, ERRORS_COLOR_LABEL } from '../../../constants/formStyleLabels';
import { COLLAPSIBLE_CONTENT, COLLAPSIBLE_SECTION } from '../../../constants/reusableClassNames';

import { ERRORS_QA, FONT_LABEL_QA } from '../../../utils/qaIdConstants';

const FormStyleEditorErrorsPanel = ({ formId, colorList, fontList, ...props }) => (
    <SuiContainer className={COLLAPSIBLE_CONTENT} data-qa={`${ERRORS_QA}--panel`}>
        <SuiContainer className={COLLAPSIBLE_SECTION} data-qa={`${ERRORS_QA}--section-color-${ERRORS_COLOR_LABEL}`}>
            <SuiLabel text={ERRORS_COLOR_LABEL} data-qa={`${ERRORS_QA}--label-color`} />
            <ColorPickerEditor
                colorList={colorList}
                firstColor={props.color}
                changeFirstColor={(id) => props.setFormErrorsColor(formId, id)}
                qaId={ERRORS_QA}
            />
        </SuiContainer>
        <SuiContainer className={COLLAPSIBLE_SECTION} data-qa={`${ERRORS_QA}--section-${FONT_LABEL_QA}`}>
            <SuiLabel text={ERRORS_FONT_LABEL} data-qa={`${ERRORS_QA}--label`} />
            <FontPickerEditor
                fontFamilyList={fontList}
                defaultFontFamily={props.font}
                onChangeFontFamily={(id) => props.setFormErrorsFont(formId, id)}
                defaultFontSize={props.fontSize}
                onChangeFontSize={(size) => props.setFormErrorsFontsize(formId, size)}
                fontFamilyQa={`${ERRORS_QA}--fontFamily`}
                fontSizeQa={`${ERRORS_QA}--fontSize`}
            />
        </SuiContainer>
    </SuiContainer>
);

FormStyleEditorErrorsPanel.propTypes = {
    colorList: PropTypes.arrayOf(PropTypes.object).isRequired,
    fontList: PropTypes.arrayOf(PropTypes.object).isRequired,
    formId: PropTypes.string.isRequired,
    color: styleShapePropTypes,
    font: styleShapePropTypes,
    fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    setFormErrorsFont: PropTypes.func.isRequired,
    setFormErrorsFontsize: PropTypes.func.isRequired,
    setFormErrorsColor: PropTypes.func.isRequired,
};

FormStyleEditorErrorsPanel.defaultProps = {
    color: getDefaultStyle(DEFAULT_ERRORS_COLOR),
    font: getDefaultStyle(DEFAULT_FONT),
    fontSize: DEFAULT_FONT_SIZE,
};

const mapStateToProps = (state, props) => {
    const formId = getFormId(state);
    const colorList = [...getColors(state), { id: null, ...getDefaultStyle(DEFAULT_ERRORS_COLOR) }];
    const fontList = getFonts(state);

    const formErrorStyles = getFormErrorStyles(state, formId);

    return {
        colorList,
        fontList,
        formId,
        ...formErrorStyles,
    };
};

const mapDispatchToProps = {
    setFormErrorsColor,
    setFormErrorsFont,
    setFormErrorsFontsize,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormStyleEditorErrorsPanel);
